import React, { useState } from 'react'
import { Card, Form, Input, Button, Typography, Space, message } from 'antd'
import { UserOutlined, LockOutlined, DatabaseOutlined } from '@ant-design/icons'
import { apiService } from '../services/api'
import { LoginRequest } from '../types/api'

const { Title, Text } = Typography

interface LoginPageProps {
  onLogin: (token: string) => void
}

const LoginPage: React.FC<LoginPageProps> = ({ onLogin }) => {
  const [loading, setLoading] = useState(false)
  const [form] = Form.useForm()

  const handleLogin = async (values: LoginRequest) => {
    setLoading(true)
    try {
      const response = await apiService.login(values)
      // Backend returns 'token' not 'access_token'
      const token = response.access_token || response.token
      if (!token) {
        throw new Error('No token received from server')
      }
      onLogin(token)

      // 存储用户信息
      localStorage.setItem('user_info', JSON.stringify(response.user))
    } catch (error: any) {
      console.error('登录失败:', error)
      message.error(error.response?.data?.message || error.response?.data?.detail || '登录失败，请检查用户名和密码')
    } finally {
      setLoading(false)
    }
  }

  const handleDemoLogin = () => {
    form.setFieldsValue({
      username: 'demo',
      password: 'demo123'
    })
  }

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '60vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      borderRadius: 12,
      margin: '0 auto',
      maxWidth: 1200
    }}>
      <Card 
        style={{ 
          width: 400, 
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
          borderRadius: 12
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <DatabaseOutlined style={{ fontSize: 48, color: '#1890ff', marginBottom: 16 }} />
          <Title level={2} style={{ margin: 0 }}>成本分析系统</Title>
          <Text type="secondary">基于 AI 的智能查询平台</Text>
        </div>

        <Form
          form={form}
          name="login"
          onFinish={handleLogin}
          layout="vertical"
          size="large"
        >
          <Form.Item
            name="username"
            label="用户名"
            rules={[{ required: true, message: '请输入用户名' }]}
          >
            <Input 
              prefix={<UserOutlined />} 
              placeholder="请输入用户名" 
            />
          </Form.Item>

          <Form.Item
            name="password"
            label="密码"
            rules={[{ required: true, message: '请输入密码' }]}
          >
            <Input.Password 
              prefix={<LockOutlined />} 
              placeholder="请输入密码" 
            />
          </Form.Item>

          <Form.Item>
            <Button 
              type="primary" 
              htmlType="submit" 
              loading={loading}
              block
              style={{ height: 44 }}
            >
              登录
            </Button>
          </Form.Item>
        </Form>

        <div style={{ textAlign: 'center', marginTop: 16 }}>
          <Space direction="vertical" size="small">
            <Text type="secondary">演示账号</Text>
            <Button 
              type="link" 
              onClick={handleDemoLogin}
              style={{ padding: 0 }}
            >
              使用演示账号登录 (demo/demo123)
            </Button>
          </Space>
        </div>

        <div style={{ 
          marginTop: 24, 
          padding: 16, 
          background: '#f5f5f5', 
          borderRadius: 8,
          textAlign: 'center'
        }}>
          <Text type="secondary" style={{ fontSize: 12 }}>
            系统特性：自然语言查询 • AI智能分析 • 实时数据可视化
          </Text>
        </div>
      </Card>
    </div>
  )
}

export default LoginPage
